export interface TipoDocumentoOption {
  code: string;
  value: string;
}

export const LISTA_TIPO_DOCUMENTO_CANDIDATO: TipoDocumentoOption[] = [
  { code: 'CC', value: 'Cédula de Ciudadanía' },
  { code: 'TI', value: 'Tarjeta de Identidad' },
  { code: 'CE', value: 'Cédula de Extranjería' },
  { code: 'PA', value: 'Pasaporte' },
  { code: 'PEP', value: 'Permiso Especial de Permanencia' },
  { code: 'PT', value: 'Permiso por Protección Temporal' }
];

export const LISTA_TIPO_DOCUMENTO_REPRESENTANTE: TipoDocumentoOption[] = 
  LISTA_TIPO_DOCUMENTO_CANDIDATO.filter((item) => item.code !== 'TI');